import * as THREE from 'three'
import Experience from '../Experience.js'
import Debug from '../Utils/Debug.js'
import Lights from './Lights.js'
import { vertexShader, fragmentShader } from './StarShader.js'
import Moon from './Moon.js'

export default class World {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.debug = new Debug()
        this.moon = new Moon()

        // Debug GUI parameters
        this.parameters = {
            materialColor: '#ff0000'
        }

        this.lights = new Lights()

        this.setObjects()
        this.setParticles()
        this.setupDebugGUI()
    }

    setObjects() {
        // Texture
        const textureLoader = new THREE.TextureLoader()
        const gradientTexture = textureLoader.load('../textures/gradients/3.jpg')
        gradientTexture.magFilter = THREE.NearestFilter

        // Material
        this.material = new THREE.MeshToonMaterial({
            color: this.parameters.materialColor, // Use the parameter color
            gradientMap: gradientTexture
        })

        // Objects
        this.objectsDistance = 4
        this.mesh1 = new THREE.Mesh(
            new THREE.TorusGeometry(1, 0.4, 16, 60),
            this.material
        )
        this.mesh2 = new THREE.Mesh(
            new THREE.ConeGeometry(1, 2, 32),
            this.material
        )
        this.mesh3 = new THREE.Mesh(
            new THREE.TorusKnotGeometry(0.8, 0.35, 100, 16),
            this.material
        )

        this.mesh1.position.x = 2
        this.mesh2.position.x = -2
        this.mesh3.position.x = 2

        this.mesh1.position.y = -this.objectsDistance * 0
        this.mesh2.position.y = -this.objectsDistance * 1
        this.mesh3.position.y = -this.objectsDistance * 2

        this.scene.add(this.mesh1, this.mesh2, this.mesh3)
    }

    setParticles() {
        const particlesCount = 200
        const positions = new Float32Array(particlesCount * 3)
        const scales = new Float32Array(particlesCount)

        for (let i = 0; i < particlesCount; i++) {
            positions[i * 3 + 0] = (Math.random() - 0.5) * 10
            positions[i * 3 + 1] = this.objectsDistance * 0.5 - Math.random() * this.objectsDistance * 3
            positions[i * 3 + 2] = (Math.random() - 0.5) * 10
            scales[i] = Math.random() * 3.0
        }

        const particlesGeometry = new THREE.BufferGeometry()
        particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
        particlesGeometry.setAttribute('aScale', new THREE.BufferAttribute(scales, 1))

        // Shader Material
        this.particlesMaterial = new THREE.ShaderMaterial({
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            transparent: true,
            vertexColors: true
        })

        // Points
        this.particles = new THREE.Points(particlesGeometry, this.particlesMaterial)
        this.scene.add(this.particles)
    }

    setupDebugGUI() {
        if (this.debug.ui) {
            this.debug.ui
                .addColor(this.parameters, 'materialColor')
                .onChange(() => {
                    this.material.color.set(this.parameters.materialColor)
                })
        }
    }

    update() {
        // Update objects if needed
    }
}